import React from 'react';

import Errors from '../Errors';
import FormRow from './FormRow';
import FormRowSubmit from './FormRowSubmit';
import FormSuccess from './FormSuccess';

const Form = React.createClass({

  propTypes: {
    disabled: React.PropTypes.bool,
    items: React.PropTypes.array,
    errors: React.PropTypes.oneOfType([
      React.PropTypes.array,
      React.PropTypes.object,
      React.PropTypes.string
    ])
  },

  getInitialState: function () {
    return {
      values: this.getValues(this.props.values)
    };
  },

  getValues(values) {
    if (!this.props.items) return {};
    let item, i, j, itm;
    for (i = 0; i < this.props.items.length; i++) {
      item = this.props.items[i];
      if (values[item.name] == null || values[item.name] === undefined) {
        if (item.type === 'cols') {
          for (j = 0; j < item.items.length; j++) {
            itm = item.items[j];
            if (values[itm.name] == null || values[itm.name] === undefined) {
              values[itm.name] = itm.value != null
                ? itm.value
                : (itm.defaultValue ? itm.defaultValue : '');
            }
          }
        } else {
          values[item.name] = item.value != null
            ? item.value
            : (item.defaultValue ? item.defaultValue : '');
        }
      }
    }
    return values;
  },

  componentWillReceiveProps: function () {
    if (this.props.stateless) {
      return;
    }

    this.setState({
      values: this.getValues(this.props.values)
    });
  },

  getDefaultProps: function () {
    return {
      disabled: false,
      submitText: 'button.send',
      className: '',
      context: null,
      values: {},
      errors: [],
      items: [],
      stateless: false
    };
  },


  handleChange: function (name, value) {
    let values;
    if (this.props.stateless) {
      values = Object.assign({}, this.props.values);
      values[name] = value;
    } else {
      values = this.state.values;
      values[name] = value;
      this.setState({ values: values });
    }
    this.props.onChange && this.props.onChange(values);
  },

  onSubmit: function (e) {
    e.preventDefault();
    this.props.onSubmit && this.props.onSubmit();
    let values = this.state.values;
    for (let key in values) {
      if (typeof values[key] == 'string') {
        values[key] = ''
      }
    }
  },

  render: function () {
    let rows = [], values, i, item;

    if (this.props.stateless) {
      values = this.getValues(Object.assign({}, this.props.values));
    } else {
      values = this.state.values;
    }

    for (i = 0; i < this.props.items.length; i++) {
      item = this.props.items[i];

      rows.push(
        <FormRow label={item.label}
          type={item.type}
          context={this.props.context}
          data={item}
          autoFocus={item.autoFocus || i === 0}
          value={values[item.name]} name={item.name}
          options={item.options}
          disabled={this.props.disabled}
          onChange={this.handleChange}
          key={i} />);
    }

    return (
      <form onSubmit={this.onSubmit}>        
        {rows}
        <Errors errors={this.props.errors} />
        <div className="form_buttons">
          {this.props.submitText ?
            <FormRowSubmit status={this.props.submitStatus} text={this.props.submitText}
              disabled={this.props.disabled} />
            : null}
          {this.props.children}
        </div>
      </form>
    );
  }
});

export default Form;



// WEBPACK FOOTER //
// ./src/js/Component/Form/Form.jsx